import React from 'react';
import {
  NavLink,
  // useLocation
} from 'react-router-dom';

import { FaBars, FaGear } from 'react-icons/fa6';
import {
  Button,
  Navbar,
  Nav,
  // NavDropdown,
} from 'react-bootstrap';
import styled from '@emotion/styled';

import useUser from 'hooks/useUser';
import {
  appRoles,
  // Roles
} from 'utils/enums';
// import Labels from 'utils/labels';
import {
  MainRoutes,
  //  ReportRoutes
} from 'helpers/routes';

const StyledNavbar = styled(Navbar)`
  background-color: var(--bs-primary);
  padding: 10px;
  .nav-link {
    padding: 0.5rem 1.5rem !important;
    color: white !important;
    &:hover {
      background-color: var(--bs-secondary);
    }
  }
  .nav-pills {
    --bs-nav-pills-border-radius: var(--bs-border-radius);
    --bs-nav-pills-link-active-color: #fff;
    --bs-nav-pills-link-active-bg: var(--bs-secondary);
  }
  .dropdown-menu {
    .dropdown-item.active {
      background-color: var(--bs-secondary);
    }
  }
  .navbar-toggler {
    color: white;
    border: 1px solid white !important;
    outline: 0 !important;
  }
`;

const NavbarCollapse = styled(Navbar.Collapse)`
  justify-content: space-between;
`;

const NavActions = styled.div`
  display: flex;
  align-items: center;
`;

const { REACT_APP_DATA_ENTRY_URL, REACT_APP_BURN_CARE_QUALITY_URL } = process.env;

const facilitiesUrl = `${(REACT_APP_BURN_CARE_QUALITY_URL || '').replace(/\/$/, '')}/view/burn_centers`;

const menuRoles = {
  burnCenters: [
    appRoles.abaADMIN,
    appRoles.bdataADMIN,
    appRoles.qualityAssurance,
    appRoles.qualityImprovement,
  ],
  users: [
    appRoles.abaADMIN,
    appRoles.bdataADMIN,
    appRoles.superUser,
    appRoles.manager,
  ],
  adminVerification: [appRoles.bdataADMIN],
};

const NavMenu = () => {
  // const { pathname } = useLocation();
  const {
    logout,
    roleName,
    appUser,
    hasReports,
    hasVerification,
    isBdataAmin,
  } = useUser();

  if (!appUser.id) return null;

  return (
    <StyledNavbar variant="dark" collapseOnSelect expand="lg">
      <Navbar.Toggle aria-controls="responsive-navbar-nav">
        <FaBars />
      </Navbar.Toggle>
      <NavbarCollapse id="responsive-navbar-nav">
        <Nav variant="pills" defaultActiveKey="link-1">
          <Nav.Item>
            <Nav.Link as={NavLink} to={MainRoutes.HOME}>
              Home
            </Nav.Link>
          </Nav.Item>
          {!!appUser.clinicalStudioRole && (
            <Nav.Item>
              <Nav.Link href={REACT_APP_DATA_ENTRY_URL}>
                Data Collection
              </Nav.Link>
            </Nav.Item>
          )}
          {hasReports && (
            <Nav.Item>
              <Nav.Link as={NavLink} to={MainRoutes.REPORTS}>
                Reports
              </Nav.Link>
            </Nav.Item>
          )}
          {roleName !== appRoles.summaryReportViewer && (
            <Nav.Item>
              <Nav.Link as={NavLink} to={MainRoutes.TRAINING}>
                Training
              </Nav.Link>
            </Nav.Item>
          )}
          {menuRoles.burnCenters.includes(roleName) && (
            <Nav.Item>
              <Nav.Link as={NavLink} to={MainRoutes.BURN_CENTERS}>
                Burn Centers
              </Nav.Link>
            </Nav.Item>
          )}
          {isBdataAmin && (
            <Nav.Item>
              <Nav.Link href={facilitiesUrl}>Facilities</Nav.Link>
            </Nav.Item>
          )}
          {appUser.burnCenterId && (
            <Nav.Item>
              <Nav.Link as={NavLink} to={MainRoutes.PROFILE}>
                Profile
              </Nav.Link>
            </Nav.Item>
          )}
          {menuRoles.users.includes(roleName) && (
            <Nav.Item>
              <Nav.Link as={NavLink} to={MainRoutes.USERS}>
                Users
              </Nav.Link>
            </Nav.Item>
          )}
          {hasVerification && (
            <Nav.Item>
              <Nav.Link as={NavLink} to={MainRoutes.VERIFICATION}>
                Verification
              </Nav.Link>
            </Nav.Item>
          )}
        </Nav>
      </NavbarCollapse>
      <NavActions>
        {isBdataAmin && (
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link
                as={NavLink}
                to={`${MainRoutes.ADMIN}/messages`}
                title="Post a Message"
                aria-label="Post a Message"
              >
                <FaGear />
              </Nav.Link>
            </Nav.Item>
          </Nav>
        )}
        <Nav.Link
          as={Button}
          onClick={() => logout({
            logoutParams: {
              returnTo: `${window.location.origin}`,
            },
          })}
        >
          Log Out
        </Nav.Link>
      </NavActions>
    </StyledNavbar>
  );
};

export default NavMenu;
